import React from 'react';

interface InfoItem {
  label: string;
  value: string | number;
}

interface InfoGridProps {
  items: InfoItem[];
}

const InfoGrid: React.FC<InfoGridProps> = ({ items }) => {
  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-2">
      {items.map((item, index) => (
        <article key={index}>
          <header>
            <label className="font-semibold text-sm">{item.label}</label>
          </header>
          <p className="border border-gray p-2 rounded bg-white">
            {item.value}
          </p>
        </article>
      ))}
    </section>
  );
};

export default InfoGrid;